import React, { useContext, useEffect, useState } from 'react';
import styles from '../ProductModal/ProductModal.module.scss';
import { addCustomPathToLink, checkIsFavourite, fetchProduct, generateKey, toggleFavourite } from '../../functions';
import { ModalContext, ModalProvider } from '../Modal/modalContext';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import { Link } from 'react-router-dom';
import ProductPrice from './ProductPrice';
import { LightBoxProvider } from '../LightBox/LightBoxContext';
import LightBoxButton from '../LightBox/LightBoxButton';
import { DataContext } from '../../views/pages/Root';

const ProductModal = ({ id }) => {
  let { handleModal } = useContext(ModalContext);
  const data = useContext(DataContext);

  const [product, setProduct] = useState(null);
  const [productLoader, setProductLoader] = useState(true);

  const [isFavourite, setIsFavourite] = useState(false);

  useEffect(() => {
    const tempProduct = fetchProduct(id, setProduct, setProductLoader, data);

    if (!!tempProduct) {
      setIsFavourite(checkIsFavourite(id));

      const localStorageSetHandler = () => {
        setIsFavourite(checkIsFavourite(id));
      };

      document.addEventListener('itemInserted', localStorageSetHandler, false);
      return (_) => {
        document.removeEventListener('itemInserted', localStorageSetHandler, false);
      };
    }
  }, []);

  useEffect((_) => {}, []);
  const ProductGallery = ({ images }) => {
    const modifiedImages = images.map((image) => ({
      ...image,
      src: addCustomPathToLink(image.src, true).replace(
        'width=1200&height=1200&format=jpg&quality=80;quality=80&amp;fit=bounds&amp;fit=bounds&amp;canvas=1200,1200',
        'width=450&height=450&format=jpg&quality=80;quality=80&amp;fit=bounds&amp;fit=bounds&amp;canvas=500,500'
      ),
    }));

    return (
      !!images && (
        <>
          <Carousel
            interval="5000"
            transitionTime="800"
            showIndicators={false}
            showStatus={false}
            renderArrowNext={(clickHandler, hasNext) => {
              return hasNext && <button className={styles.btn_next} onClick={clickHandler}></button>;
            }}
            renderArrowPrev={(clickHandler, hasNext) => {
              return hasNext && <button onClick={clickHandler} className={styles.btn_prev}></button>;
            }}
          >
            {modifiedImages.map((image) => (
              <div key={generateKey()}>
                <img className={styles.imageProduct} src={image.src} srcSet={image.srcSet} alt={image.alt} />
                <LightBoxProvider>
                  <LightBoxButton image={image} />
                </LightBoxProvider>
              </div>
            ))}
          </Carousel>
        </>
      )
    );
  };

  return (
    <div id="#product-modal" className={styles.productModal} onClick={() => handleModal()}>
      {productLoader ? (
        '...'
      ) : !!product ? (
        <div className={styles.innerWrapper} onClick={(e) => e.stopPropagation()}>
          <div className={styles.productImage}>{!!product?.images && <ProductGallery images={product.images} />}</div>
          <div className={styles.productInfo}>
            {!!product?.lables && <span className={styles.productLabels}>{product.labels}</span>}
            {!!product?.name && <h3 className={styles.productTitle}>{product.name}</h3>}
            <ProductPrice product={product} />
            {!!product?.salePrice && !!product?.regularPrice && (
              <div className={styles.productSaleDate}>
                <p className={styles.productInfoDate}>
                  Oferta ważna od {!!product?.saleStartDate && <span className={styles.productSaleStartDate}>{product.saleStartDate}</span>} do{' '}
                  {!!product?.saleEndDate && <span className={styles.SaleEndDate}>{product.saleEndDate}</span>} Sprzedaż do wyczerpania zapasu.
                </p>

                <p className={styles.productInfoDate}>
                  Najniższa cena w okresie 30 dni przed obniżką:
                  {!!product?.lowestPrice && <span className={styles.LowestPrice}> {product.lowestPrice}</span>}
                  {!!product?.currency && <span className={`${styles.productCurrency}`}>{product.currency}</span>}
                  {!!product?.currencySuffix && <span className={`${styles.productCurrency}`}>{product.currencySuffix}</span>}
                </p>
              </div>
            )}
            <p>
              <button
                className={`${styles.btnHeart} ${isFavourite ? styles.btnHeartFull : styles.btnHeartEmpty}`}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  toggleFavourite(product.id);
                  setIsFavourite(!isFavourite);
                }}
              >
                {isFavourite ? 'Usuń z listy życzeń' : 'Dodaj do listy życzeń'}
              </button>
              <button className={styles.btnClose} onClick={() => handleModal()}></button>
              <p className={styles.productIndex}>
                Nr ref.:
                {!!product?.id && <p className={styles.productRef}>{product.id}</p>}
              </p>
            </p>
            {!!product?.desc && <p className={styles.productDesc}>{product.desc}</p>}
            {!!product.additionalInfo && (
              <div className={styles.productSugg}>
                {product.additionalInfo.map((item) => (
                  <p className={styles.productCharact} key={generateKey()}>
                    {item.key}: <span>{item.value}</span>
                  </p>
                ))}
              </div>
            )}
            <Link className={styles.btnShop} target="_blank" to={!!product?.linkToShop ? product.linkToShop : ''}>
              Przejdź do sklepu
            </Link>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ProductModal;
